<template>
  <div class="container homeLayout">
    <el-row class="homeHeader">
      <div class="homeTitle">{{$t('GENERAL_titulo_bienvenida')}}</div>
      <a href="https://www.colven.com.ar" target="_blank">
        <div class="homeDescription">{{$t('GENERAL_mensaje_bienvenida')}}</div>
      </a>
    </el-row>
    
    <el-row class="seccion">
      <el-col :span="16" class="seccionNoticias container_col_1">
        <div class="seccionContainer">
          <div class="sectionTitle">{{$t('NOTICIAS_noticias')}}</div>
          <Noticias :data="noticias" />
        </div>
      </el-col>

      <el-col :span="8" class="seccionArchivos container_col_2">
        <div class="seccionContainer">
          <!-- jerarquia de archivos  -->
          <div class="sectionTitle">
            <el-row>
              <el-col :span="8">{{$t('ARCHIVOS_archivos')}}</el-col>           
            </el-row>
          </div>
          <el-row>
            <!-- loader de archivos  -->
            <div v-if="cargandoArchivos" class="loader">
              <i class="el-icon-loading primary"></i>
              <div class="primary text-loader">{{$t('GENERAL_cargando')}} {{ $t('ARCHIVOS_archivos')}}</div>
            </div>
            <div v-else>
              <el-tree 
                class="nodeTree" 
                :data="dataFiles" 
                :props="defaultProps" 
                node-key="Id"
                ref="tree"
              >
              <!-- diseño de los labels del arbol dependiendo si se trata de un archivo o carpeta -->
              <span slot-scope="{node, data}">
                <!-- archivos de tipo archivo -->
                <span v-if="data.EsArchivo">
                  <i :class="data.TipoArchivo == 1 ? 'iconFile el-icon-document' : 'iconFile el-icon-paperclip'"></i>
                  <span>{{node.label}}</span>
                  <span v-if="node.isLeaf == true">
                    <i v-if="!descargandoArchivo" :class="data.TipoArchivo == 1 ? 'iconFile el-icon-download' : 'iconFile el-icon-top-right'" 
                      @click="data.TipoArchivo == 1 ? downloadArchivo(data.Id) : abrirEnlace(data.Id)"
                    ></i>
                    <i v-else class="el-icon-loading primary"></i>
                  </span>
                </span>
                <!-- archivos de tipo carpeta -->
                <span v-else>
                  <!-- leyenda de que la carpeta no contiene archivos  -->
                  <span v-if="data.EstaVacio == true">
                    <span class="leyenda">{{ $t('ARCHIVOS_carpeta_vacia')}}</span>
                  </span>
                  <!-- evento para pedir los hijos de la carpeta seleccionada  -->
                  <span v-else @click="getHijos(data, node)">
                    <i class="iconFile el-icon-folder" ></i>
                    <span> {{node.label}} </span>
                  </span>
                  <span>
                    <i v-if="!descargandoArchivo" :class="'iconFile el-icon-download'" 
                      @click="downloadArchivo(data.Id)"></i> <!--Descargo la carpeta y sus hijos-->
                    <i v-else class="el-icon-loading primary"></i>
                  </span>
                </span>
              </span>
              </el-tree>
            </div>
          </el-row>
        </div>
        <!-- Seccion Ultimos foros modificados o con actividad -->
        <el-row >
          <div class="seccionContainer">
            <div class="sectionTitle">
              <el-row>
                <el-col :span="8">{{ $t('FORO_foros') }}</el-col>

                <el-col :span="16" style="text-align: right">
                  <el-pagination
                    background
                    :small="true"
                    layout="prev, pager, next"
                    :total="paginadorForos.totalObjects"
                    :page-size="paginadorForos.pageSize"
                    :pager-count="5"
                    hide-on-single-page
                    @current-change="onForoPageChange"
                  />
                </el-col>
              </el-row>
            </div>
            <!-- loader foros -->
            <div v-if="cargandoForos" class="loader">
              <i class="el-icon-loading primary"></i>
              <div class="primary text-loader">{{$t('GENERAL_cargando')}} {{ $t('FORO_foros')}}</div>
            </div>
            <div v-else>
              <Foros :data="foros" />
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Noticias from './noticia'
  import Archivos from './archivo'
  import Foros from './foro'
  import { showError } from '../Mensaje'

  const cantidadEntradas = 4;

  export default {
    name: "Home",
    components: { Noticias, Archivos, Foros },

    data() {
      return {
        noticias: [],
        archivos: undefined,
        foros: undefined,

        paginadorArchivos: {
          page: 0,
          pageSize: 4,
          totalObjects: 0
        },
        paginadorForos: {
          page: 0,
          pageSize: cantidadEntradas,
          totalObjects: 0,
        },
        // variable para controlar los loaders
        descargandoArchivo: false, 
        cargandoArchivos: false,
        cargandoForos: false,
        dataFiles: undefined,
        //definimos las props del tree
        defaultProps: {
          id: 'Id',
          children: 'Hijos',
          label: 'Nombre',
          isLeaf: 'EsArchivo',
          isEmpty: 'EstaVacio'
        },

      }
    },

    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
        perfiles: state => state.sesion.resultadoAutenticacion.Perfiles
      })
    },

    methods: {
      getHijos(nodo, nodoConfig)
      {
        // pido los hijos si es que no fueron cargados ya
        if(!nodo.HijosCargados)
        {
          let payload = {
            idUsuario: this.idUsuario,
            idPerfiles: this.perfiles.map(x => x.Id),
            idNodo: nodo.Id
          }

          // activo el loader
          nodoConfig.loading = true;
          this.$store.dispatch('archivos/getArchivosJerarquia', payload)
          .then(data => { 
            nodo.HijosCargados = true;
            nodo.Hijos = data.Datos;
            if(nodo.Hijos.length === 0){
              //nodo.Hijos.EstaVacio = true;
              nodo.Hijos.push({EstaVacio:true});
            }
            nodoConfig.expanded = true;
          })
          .finally(() => nodoConfig.loading = false)
        }
      },
      getNoticias()
      {
        // busco todas las noticias publicadas (ignora la paginación)
        this.$store.dispatch('noticias/getNoticiasPublicadas', { page: 0, pageSize: 1000 })
        .then(data => this.noticias = data.Result)
      },
      getArchivos()
      {
        
        let payload = {
          idUsuario: this.idUsuario,
          idPerfiles: this.perfiles ? this.perfiles.map(x => x.Id) : "",
          //idPerfiles: this.perfiles.map(x => x.Id),
          idNodo: undefined
        }
        this.cargandoArchivos = true;
        this.$store.dispatch('archivos/getArchivosJerarquia', payload)
        .then(data => { 
          this.archivos = data.Datos;
          this.dataFiles = this.archivos;
        })
        .finally(() => this.cargandoArchivos = false)
      },

      onArchivoPageChange(page) 
      {
        this.paginadorArchivos.page = page-1
        this.getArchivos()
      },
      getForos(){
        // busco los foros por usuario y perfil
        let payload = {
          //el estado se agrego para probar una consulta que no va
          //estado: 1,
          page: this.paginadorForos.page,
          pageSize: this.paginadorForos.pageSize,
          cantidadEntradas: cantidadEntradas,
          //idUsuario: this.idUsuario,
          //perfiles va?
          //idPerfiles: this.perfiles.map(x => x.Id)
        }
        this.cargandoForos = true;
        this.$store.dispatch('foro/getUltimasEntradasForo', payload)
        .then(data => { 
          this.foros = data.Result
          this.paginadorForos.totalObjects = data.TotalObjects
        })
        .finally(() => this.cargandoForos = false)
      },
      onForoPageChange(page){
        this.paginadorForos.page = page-1;
        this.getForos();
      },
      abrirEnlace(idFile, nodo)
      {
        // activo el loader
        this.descargandoArchivo = true;
        // descargo el archivo exportado
        this.$store.dispatch('archivos/getLink', { idArchivo: idFile }).then(response => { 
          //console.log(response);
          window.open(response, '_blank');  
        }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
        .finally(() => this.descargandoArchivo = false)
      },
      downloadArchivo(idFile, nodo) 
      {
        // activo el loader
        this.descargandoArchivo = true;
        
        // descargo el archivo exportado
        let payload = {
          idUsuario: this.idUsuario,
          idPerfiles: this.perfiles ? this.perfiles.map(x => x.Id) : "",
          //idPerfiles: this.perfiles.map(x => x.Id),
          idNodo: idFile
        }
        this.$store.dispatch('archivos/downloadFile', payload).then(response => {   
          // obtengo el content type y el file name
          let mimeType = response.headers["content-type"]
          let contentDisposition = response.headers["content-disposition"]
          let fileName = contentDisposition.split("; filename=")[1]
          fileName = fileName.replace(/"/g, "");
          fileName = decodeURIComponent(fileName)

          // genero un blob con la respuesta
          let blob = new Blob([response.data], { type: mimeType });
          
          // descargo el archivo
          if (navigator.msSaveOrOpenBlob) 
          {
              navigator.msSaveBlob(blob);
          } 
          else 
          {
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.target = '_blank'
              link.setAttribute('download', fileName);
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
          }
        }).catch(() => showError(this.$t('ARCHIVOS_error_descarga')))
        .finally(() => this.descargandoArchivo = false)
      }

    },

    mounted() 
    {
      //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
       
      this.getNoticias();
      this.getForos();
      this.getArchivos();
      
    },
  }

</script>

<style scoped>

  .loader
  {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100px;
  }
  .loader i
  {
    color:var(--main-color);
    font-size: 50px;
  }
  .loader .text-loader
  {
    font-size: 12px;
    margin-top: 5px;
  }
  .leyenda
  {
    font-size: 15px;
    margin-top: 10px; 
    margin-left: 20px;
    color: #999;
  }
  .homeLayout {
    padding: 0px 20px 0px 0px;
    margin-top: -10px;
  }

  .homeHeader {
    text-align: left;
    background-color: var(--main-color);
    color: #ffffff;
    margin-bottom: 15px;
    padding: 15px;
  }

  .homeHeader .homeTitle {
    font-size: 35px;
    margin-bottom: 10px;
  }

  .homeHeader .homeDescription {
    font-size: 12px;
    color: #ffffff;
  }

  .seccionContainer {
    padding: 10px;
    background-color: var(--main-color)14;
  }

  .seccionNoticias {
    padding-right: 20px;
  }

  .seccionArchivos {
    padding-left: 20px;
  }
  .iconFile{
    margin: 5px;
  } 

  .sectionTitle {
    font-size: 22px;
    text-align: left;
    color: var(--main-color);
    margin-bottom: 10px;
    border-bottom: 2px solid var(--main-color);
  }

  @media(min-width: 1600px)
  {
    .homeHeader {
      margin-bottom: 30px;
      padding: 30px 15px;
    }

    .homeHeader .homeTitle {
      font-size: 40px;
    }

    .homeHeader .homeDescription {
      font-size: 16px;
    }

    .seccionContainer {
      padding: 20px;
    }

    .sectionTitle {
      font-size: 24px;
      margin-bottom: 10px;
    }
  }

  @media (max-width: 1000px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width:100% !important;
  }
  .container_col_2 {
    flex: 1;
    width:100% !important;
    margin-top:20px;
  }
  .seccionNoticias {
    padding-right: 0px;
  }
  .seccionArchivos {
    padding-left: 0px;
  }

  @media(max-width: 600px) {
    .homeLayout {
      margin-top: 0px;
    }
  }
}

</style>

<style>
  .el-icon-folder{
    font-weight: 200;
    color: #606266;
  }

  .nodeTree .el-tree-node__expand-icon {
    margin: 5px -7px;
    transform: none;
    color: transparent;
  }
  .nodeTree .el-tree-node__content{
    background-color: var(--main-color)14;
  }
  .nodeTree .el-tree-node__content:hover{
    background-color: white;
  }
  .el-tree-node__loading-icon
  {
    font-weight: bold;
    color:var(--main-color);
    margin-right: 0px;
  }
  .seccionNoticias .el-carousel {
    background-color: #f4f4f5;
  }

  .seccionArchivos .el-pagination.el-pagination--small {
    padding: 0px;
  }

  .seccionArchivos .el-pagination.el-pagination--small > button,
  .seccionArchivos .el-pagination.el-pagination--small > ul
  {
    margin-top: 1px !important;
  }

  .seccionArchivos .el-card__body {
    padding: 10px !important;
  }

  @media(min-width: 1600px)
  {
    .seccionArchivos .el-pagination.el-pagination--small > button,
    .seccionArchivos .el-pagination.el-pagination--small > ul
    {
      margin-top: 3px !important;
    }

    .seccionArchivos .el-card__body {
      padding: 20px !important;
    }
  }

</style>